import { Industry } from "@monsterindia/global-ui-components";
import Image from "next/image";
import React from "react";

interface JobDescHeaderProps {
  data: any;
  isMobile: boolean;
  mediaUrl: string;
}

const JobDescHeader: React.FC<JobDescHeaderProps> = ({
  data,
  isMobile,
  mediaUrl,
}) => {
  return (
    <div
      className={`bg-jdPage-gradient relative flex md:rounded-t-2xl ${isMobile ? "!-ml-4 !-mr-4 !-mt-4 min-h-[90px]" : "min-h-[94px]"}`}
    >
      <div className="absolute left-4 top-[50px] flex h-[58px] w-[58px] items-center justify-center rounded border border-[#F4F4F5] bg-white p-[1px] md:!left-[24px] md:!top-[45px] md:!h-[70px] md:!w-[70px]">
        {data.jobDetails?.companyLogoUrl ? (
          <Image
            src={data.jobDetails?.companyLogoUrl}
            alt={data.jobDetails?.companyName}
            height={isMobile ? 48 : 56}
            width={isMobile ? 48 : 56}
            // fill={true}
          />
        ) : (
          <div className="bg-decorative-surface-03 flex h-[48px] w-[48px] items-center justify-center self-center md:!h-[56px] md:!w-[56px]">
            <Industry width={24} height={24} fill="#5A0A40" />
          </div>
        )}
      </div>
      {data.jobDetails?.isGptwCompany ? (
        <div className="absolute right-6 top-[-1px] h-[63px] w-[36px]">
          <Image
            src={`https://${mediaUrl}/public/core/images/gptw.png`}
            alt="certified job"
            layout="fill"
            objectFit="contain"
          />
        </div>
      ) : null}
    </div>
  );
};

export default React.memo(JobDescHeader);
